import * as React from 'react';
import axios from 'axios';
import * as _ from 'lodash';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';

export default class TagsAutocomplete extends React.Component<any, any> {
  private URL = process.env.REACT_APP_PACKAGES_URL;
  private apikey = process.env.REACT_APP_PACKAGES_APIKEY;
  private settings: any = {
    emptyOnSelect: true,
    multiple: false,
    clearable: false,
  }
  private ref: any = React.createRef();

  constructor(props: any) {
    super(props);

    this.state = {
      defaultSelected: this.props.defaultSelected
        ? _.cloneDeep(this.props.defaultSelected)
        : [],
      options: [],
      isLoading: false,
    };

    const { settings } = this.props;
    if (settings) {
      this.settings = Object.assign({}, this.settings, settings);
    }

    this.request = this.request.bind(this);
  }

  public render() {
    return (
      <AsyncTypeahead
        defaultSelected={this.state.defaultSelected}
        options={this.state.options}
        isLoading={this.state.isLoading}
        multiple={this.settings.multiple}
        labelKey="name"
        ref={(ref: any) => this.ref = ref}
        renderMenuItemChildren={(option: any) => {
          return (
            <div key={`${option.id}`}>
              #{option.name}
            </div>
          );
        }}
        onChange={(selected: any) => {
            if (!selected.length && !this.settings.multiple) {
              return;
            }

            if (this.settings.multiple) {
              this.props.onSelected(selected.map((s: any) => _.pick(s, ['_id', 'slug', 'name'])));
            } else {
              const [item] = selected;
              this.props.onSelected(_.pick(item, ['_id', 'slug', 'name']));
            }

            if (this.settings.emptyOnSelect) {
              this.ref.getInstance().clear();
            }
        }}
        minLength={3}
        onSearch={this.request}
        emptyLabel="Sin resultados"
      />
    );
  }

  private async request(query: string): Promise<any> {
    console.log(`Fetch ${query}`);
    this.setState({ isLoading: true });

    const options: any = {
      method: 'GET',
      url: `${this.URL}/api/tags`,
      params: {
        where: {
          name:{ $regex: `${query}.*`, $options: 'i' },
        },
      },
      headers: {
        apikey: this.apikey,
      },
    };

    const { data } = await axios(options);

    this.setState({ options: data, isLoading: false });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/TagsAutocomplete.tsx